import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLanguage } from '../../contexts/LanguageContext';
import useScrollLock from '../../hooks/useScrollLock';
import './Salon.css';

const ReviewPtoModal = ({ isOpen, onClose, salonId, request, decision, onReviewed }) => {
  const { t, formatWeddingDate } = useLanguage();
  const [reviewNote, setReviewNote] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useScrollLock(isOpen);

  useEffect(() => {
    if (isOpen) {
      setReviewNote('');
      setError('');
    }
  }, [isOpen]);

  if (!isOpen || !request) return null;

  const willGoNegative = decision === 'approved' &&
    request.requester_balance !== null && request.requester_balance !== undefined &&
    (parseFloat(request.requester_balance) - parseFloat(request.days_count)) < 0;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    if (willGoNegative && !window.confirm(t('timeOff.pto.confirmNegativeBalance', undefined, {
      balance: (parseFloat(request.requester_balance) - parseFloat(request.days_count)).toString()
    }))) {
      return;
    }

    setLoading(true);
    setError('');

    try {
      const token = localStorage.getItem('token');
      await axios.put(`/api/salons/${salonId}/pto/requests/${request.id}/review`, {
        decision,
        review_note: reviewNote
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setLoading(false);
      onReviewed();
    } catch (err) {
      console.error('Error reviewing PTO request:', err);
      setError(err.response?.data?.error || t('timeOff.pto.failedToReview'));
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-header">
          <h3>{decision === 'approved' ? t('timeOff.pto.approve') : t('timeOff.pto.reject')}</h3>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          <p>
            {t('timeOff.pto.employee')}: <strong>{request.first_name} {request.last_name}</strong><br />
            {formatWeddingDate(request.start_date)} → {formatWeddingDate(request.end_date)} ({request.days_count} {t('timeOff.pto.days')})
          </p>

          {willGoNegative && (
            <div className="error-message">
              {t('timeOff.pto.negativeBalanceWarning', undefined, {
                balance: (parseFloat(request.requester_balance) - parseFloat(request.days_count)).toString()
              })}
            </div>
          )}

          <form onSubmit={handleSubmit} id="review-pto-form" noValidate>
            <div className="form-group">
              <label htmlFor="review_note">{t('timeOff.pto.reviewNote')} ({t('common.optional')})</label>
              <textarea
                id="review_note"
                value={reviewNote}
                onChange={(e) => setReviewNote(e.target.value)}
                maxLength={500}
                rows={3}
              />
            </div>

            {error && <div className="error-message">{error}</div>}
          </form>
        </div>

        <div className="modal-footer">
          <button type="button" className="salon-button secondary" onClick={onClose} disabled={loading}>
            {t('common.cancel')}
          </button>
          <button type="submit" form="review-pto-form" className="salon-button primary" disabled={loading}>
            {loading ? `${t('common.confirm')}...` : t('common.confirm')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReviewPtoModal;
